import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faFilm, faImage, faFile } from '@fortawesome/free-solid-svg-icons';

class MediaFile {
    static getMediaType(media, mediafiles) {
        if (!media || !media.length) {
            return MediaFile.getMediaTypeFromMediafiles(mediafiles);
        }

        if (media.indexOf("video") !== -1 || media.indexOf("sourcevideo") !== -1) {
            return 'video';
        }
        if ((media.indexOf("audio") !== -1)) {
            return 'audio';
        }
        if (media.indexOf("pictures") !== -1 && media.indexOf("video") === -1) {
            return 'pictures';
        }
        

        if ((media.indexOf("pictures") === -1 && media.indexOf("video") === -1 && media.indexOf("audio") === -1)) {
            return 'other';
        }
        
        return 'other';
    }
    
    static getMediaTypeFromMediafiles(mediafiles) {
        if(!mediafiles || !mediafiles.length) return 'empty';
		//if(!mediafiles || !mediafiles.length) return 'other';
        
        mediafiles.sort((a, b) => {
            if(a.getId() < b.getId()) {
                return -1;
            }
            if(a.getId() > b.getId()) {
                return 1;
            }
            return 0;
        });
        
        const ext = MediaFile.getFileExtention(mediafiles[0].getFilename());
        
        if(ext) {
            if(MediaFile.hasVideoExt(ext)) return 'video';
            if(MediaFile.hasAudioExt(ext)) return 'audio';
            if(MediaFile.hasImageExt(ext)) return 'pictures';
        }
        
        return 'other';
    }
    
    static hasAudioExt(ext, exclude = []) {
        // https://caniuse.com/?search=audio%20format
        const validExt = ["wav", "mp3", "ogg", "flac", "aac"];
        
        const arr = validExt.filter(item => !exclude.includes(item));
        
        return arr.includes(ext);
        //return validExt.includes(ext);
    }
    
    static hasVideoExt(ext, exclude = []) {
        // https://en.wikipedia.org/wiki/HTML5_video
        const validExt = ["webm", "mp4", "ogg", "mov", "m4v"];
        
        const arr = validExt.filter(item => !exclude.includes(item));
        
        return arr.includes(ext);
        //return validExt.includes(ext);
    }
    
    static hasImageExt(ext, exclude = []) {
        // https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
        const validExt = ["apng", "avif", "gif", "jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "bmp", "ico", "cur", "tif", "tiff"];
        
        const arr = validExt.filter(item => !exclude.includes(item));
        
        return arr.includes(ext);
        //return validExt.includes(ext);
    }
    
    static hasPdfExt(ext, exclude = []) {
        const validExt = ["pdf"];
        
        const arr = validExt.filter(item => !exclude.includes(item));
        
        return arr.includes(ext);
        //return validExt.includes(ext);
    }
    
    static isPlayable(file) {
        const ext = MediaFile.getFileExtention(file.getFilename());
        if(ext) {
            if(MediaFile.hasVideoExt(ext, ["mov"])) return true;
            if(MediaFile.hasAudioExt(ext)) return true;
            if(MediaFile.hasImageExt(ext, ["tif","tiff"])) return true;
            if(MediaFile.hasPdfExt(ext)) return true;
        }
        return false;
    }
    
    static isFileTypeX(file, callback) {
         if(!file || !MediaFile.hasFileExtention(file.getFilename())) {
            return false;
        }
        const ext = MediaFile.getFileExtention(file.getFilename());
        return callback(ext);
    }
    
    static isVideo2(file) {
        return MediaFile.isFileTypeX(file, MediaFile.hasVideoExt);
    }
    
    static isImage2(file) {
        return MediaFile.isFileTypeX(file, MediaFile.hasImageExt);
    }
    
    static isPdf(file) {
        return MediaFile.isFileTypeX(file, MediaFile.hasPdfExt);
    }
    
    
    /*static getMediaFileIcon(file, cls, callback) {
        const ext = MediaFile.getFileExtention(file.getFilename());
        if(ext) {
            if(MediaFile.hasVideoExt(ext)) return (<FontAwesomeIcon className={cls} icon={faFilm} />);
            if(MediaFile.hasAudioExt(ext)) return (<FontAwesomeIcon className={cls} icon={faMusic} />);
            if(MediaFile.hasImageExt(ext)) {
                const url = file.getUrl();
                return url ? url : (<FontAwesomeIcon className={cls} icon={faImage} />);
            }
        }
        return (<FontAwesomeIcon className={cls} icon={faFile} />);
    }*/

    static shouldShow(media, mediafiles, filter) {
        if (filter.indexOf(MediaFile.getMediaType(media, mediafiles)) > -1) {
            return true;
        }
        return false;
    }

    static getFileExtention(fname) {
        return fname ? fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase() : null;
    }

    static getFileIcon(fname) {
        const icons = { doc: 'file-word', docx: 'file-word', xls: 'file-excel', xlsx: 'file-excel', wav: 'music', mp3: 'music', wma: 'music', ogg: 'music', pdf: 'file-pdf' }
        if (icons.hasOwnProperty(MediaFile.getFileExtention(fname))) {
            return icons[MediaFile.getFileExtention(fname)];
        }
        return 'file';
    }

    static formatBytes(bytes) {
        return (bytes / 1000000).toFixed(2) + ' MB';
    }

    static isAudio(fname) {
        const formats = ['mp3', 'wav', 'ogg', 'aac'];
        return formats.indexOf(MediaFile.getFileExtention(fname)) !== -1;
    }
    
    static isAAC(fname) {
        const formats = ['aac'];
        return formats.indexOf(MediaFile.getFileExtention(fname)) !== -1;
    }

    static isVideo(mediafile) {
        return mediafile && mediafile.videocodec;
    }

    static isImage(mediafile) {
        return mediafile && /*mediafile.height && mediafile.width &&*/ !mediafile.videocodec;
    }

    static hasFileExtention(fname) {
        return MediaFile.getFileExtention(fname) ? true : false;
    }

    static getAudioMIME(fname) {
        const mime = { mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', aac: 'audio/aac' };
        return mime[MediaFile.getFileExtention(fname)];
    }

    static getCorrectAspectRatio(file, size) {
        if (file.height > file.width) {
            let ratio = file.width / file.height;
            let width = parseInt(size * ratio);
            return width + "x" + size;
        }
        if (file.width > file.height) {
            let ratio = file.height / file.width;
            let height = parseInt(size * ratio);
            return size + "x" + height;
        }
        return size + "x" + size;
    }

    static getInformation(file) {
        let info = [];
        let ext = file.getFilename().split('.').pop().toLowerCase();

        info.push((file.width && file.height) ? (file.width + "x" + file.height) : "-");
        info.push(file.filesize ? MediaFile.formatBytes(file.filesize) : "-");
        if (file.aspect_ratio) {
            info.push(file.aspect_ratio || "-");
        }
        info.push(ext || "-");

        return info.join(' | ');
    }
    
    static getDownloadList(clip) {
        const list = [];
        if (clip && clip.mediafiles) {
            clip.mediafiles.forEach((file, index) => {
                list.push({ ...file, information: MediaFile.getInformation(file) });
            });

            list.sort(function (a, b) {
                if (a.information < b.information) { return -1; }
                if (a.information > b.information) { return 1; }
                return 0;
            });
        }

        return list;
    }
    
    static getPdfDownloadList(clip, intl) {
        const list = [];
        if (clip && clip.mediafiles) {
            clip.mediafiles.forEach((file, index) => {
                if(MediaFile.isPdf(file)) {
                    list.push({ ...file, information: MediaFile.getPdfInfo(file, intl) });
                }
            });

            list.sort(function (a, b) {
                if (a.information < b.information) { return -1; }
                if (a.information > b.information) { return 1; }
                return 0;
            });
        }

        return list;
    }
    
    static getPdfInfo(file, intl) {
        let info = [];
        
        const ext = MediaFile.getFileExtention(file.getFilename());
        const langs = [];
        const tags = file.getTags();
        const tagArray = (tags && tags.split(';')) || [];

        tagArray.forEach((tag) => {
            if (tag.length === 2) {
                langs.push(intl.formatMessage({ id: "metadata.clip.videoLanguage.dropdown."+tag }));
            }
        });

        info.push((langs.length && langs.join(", ")) || "-");
        info.push(ext);
        info.push(file.filesize ? MediaFile.formatBytes(file.filesize) : "-");

        return info.join(' | ');
    }
	
	static localURL() {
		return (window.location.origin.indexOf("localhost") !== -1) ? "https:" : "";
	}
	
	static mediafileHasTag(mediafiles, tag) {
        if(!mediafiles || !mediafiles.length) {
            return false;
        }
        
        for(let i = 0; i < mediafiles.length; i++) {
            const tags = mediafiles[i].getTags();
            if(tags && tags.indexOf(tag) !== -1) {
                return true;
            }
        }
        return false;
    }
}

export default MediaFile;
